Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DBufferUsage = module.exports.default = {
	DYNAMIC_DRAW: "dynamicDraw",
	STATIC_DRAW: "staticDraw"
};